<template>
  <div>
    <v-main>
      <v-container fluid>
        <!-- <app-headline :title="title" /> -->

        <leave-pending-detail-header
          :leaveOrderData="leaveOrderData"
          :title="title"
        />
        <v-row class="pa-0 ma-0">
          <v-col cols="12" md="7" class="hidden-xs-only">
            <app-pdf-previewonpage
              :value="loading"
              :queryParams="dataparam"
              @loadDone="onLoadDone"
            />
          </v-col>
          <v-col
            cols="12"
            md="5"
            :class="$vuetify.breakpoint.xsOnly ? 'pa-0' : 'px-1 py-0'"
            :order="$vuetify.breakpoint.smAndDown ? 1 : 2"
          >
            <v-col cols="12" class="ma-0 mt-n3">
              <leave-approve-approval
                v-if="leaveTimeline.length > 0"
                :approveNumber="leaveTimeline.length"
              />
            </v-col>
            <v-col cols="12" class="ma-0">
              <leave-pending-detail-timeline :leaveTimeline="leaveTimeline" />
            </v-col>
          </v-col>
        </v-row>
        <!-- <v-row class="pa-0 ma-0">
          <v-col
            cols="12"
            md="6"
            style="align-self: start"
            class="ma-0"
            :class="$vuetify.breakpoint.xsOnly ? 'pa-0' : 'px-2 py-0'"
            :order="$vuetify.breakpoint.smAndDown ? 2 : 1"
          >
            <leave-pending-detail-timeline :leaveTimeline="leaveTimeline" />
          </v-col>
        </v-row> -->
      </v-container>
    </v-main>
  </div>
</template>

<script>
import LeavePendingDetailHeader from '@/components/leave/LeavePending/LeavePendingDetailHeader'
import LeavePendingDetailTimeline from '@/components/leave/LeavePending/LeavePendingDetailTimeline'
import LeaveApproveApproval from '@/components/leave/LeaveApprove/LeaveApproveApproval'

export default {
  components: {
    LeavePendingDetailHeader,
    LeavePendingDetailTimeline,
    LeaveApproveApproval
  },

  data() {
    return {
      leaveOrderData: {},
      leaveTimeline: [],
      loading: false
      // dataparam: {
      //   store: 'leave/getLeaveDocumentDownload',
      //   FileType: 'pdf',
      //   guid: '7EE64993-117B-436C-AE36-91068FB8F185',
      //   leaveOrderID: 'RL65000003'
      // }
    }
  },

  computed: {
    title() {
      return 'การเห็นชอบ/อนุญาตการลา'
    },
    dataparam() {
      return {
        store: 'leave/getLeaveDocumentDownload',
        FileType: 'pdf',
        guid: this.$guid,
        leaveOrderID: this.$route.params.leaveOrderId
      }
    }
  },

  async mounted() {
    const response = await this.apiGetLeaveTimeline()
    // const leaveData = response?.data?.data[0] || null
    if (response?.data?.data) {
      const leaveData = response?.data?.data[0] || null
      //console.log(leaveData)
      const begindate =
        this.$lang === 'Tha'
          ? this.$dateFormatByLang(leaveData.leaveBeginDate, {
              format: 'DD MMMM YYYY',
              addUnit: 'y',
              addValue: 543
            })
          : this.$dateFormat(leaveData.leaveBeginDate, {
              format: 'DD MMMM YYYY',
              locale: 'en'
            })
      const finishdate =
        this.$lang === 'Tha'
          ? this.$dateFormatByLang(leaveData.leaveFinishDate, {
              format: 'DD MMMM YYYY',
              addUnit: 'y',
              addValue: 543
            })
          : this.$dateFormat(leaveData.leaveFinishDate, {
              format: 'DD MMMM YYYY',
              locale: 'en'
            })

      this.leaveOrderData = {
        leaveOrderId: leaveData.leaveOrderID,
        leaveOrder: leaveData[`leaveTypeName${this.$lang}`]
          ? leaveData.leaveOrderID +
            ' - ' +
            leaveData[`leaveTypeName${this.$lang}`]
          : leaveData.leaveOrderID + ' - ',
        employeeName: leaveData[`employeeName${this.$lang}`]
          ? leaveData[`employeeName${this.$lang}`]
          : this.$t('noData'),
        date:
          begindate +
          ' - ' +
          finishdate +
          ' จำนวน ' +
          leaveData.leaveAmountDayText,
        document: leaveData.docFileName
      }

      if (leaveData.data) {
        this.leaveTimeline = leaveData.data.map(item => {
          let res = {}
          res.name = item[`leaveStatusName${this.$lang}`] || this.$t('noData')
          res.approved = item.employeeApproveName || null
          res.color = item.color || 'primary'

          if (item.processDate) {
            res.date = this.$dateFormatByLang(item.processDate, {
              format: 'DD MMMM YYYY HH:mm:ss'
            })
          } else {
            res.date = null
          }

          if (item.approveStatusID === 'W') {
            res.reason = null
          } else {
            res.reason = item.description
          }

          if (item.backEmployeeName) {
            res.reject = {
              date: this.$dateFormatByLang(item.backDate, {
                format: 'DD MMMM YYYY HH:mm:ss'
              }),
              name: item.backEmployeeName || '',
              description: item.backDescription || ''
            }
          } else {
            res.reject = null
          }

          return res
        })
        this.leaveTimeline.reverse()
      }
    }
    this.loading = true
  },

  methods: {
    async apiGetLeaveTimeline() {
      try {
        const payload = {
          leaveOrderId: this.$route.params.leaveOrderId,
          employeeId: this.$guid
        }
        const res = await this.$store.dispatch(
          'leave/getLeaveTimeline',
          payload
        )
        return res
      } catch (e) {
        console.log(e.response || e)
      }
    },
    onLoadDone() {
      this.loading = false
    }
  }
}
</script>
